<section class="ftco-section ftco-no-pt ftco-no-pb ftco-services-2 bg-light" style="margin: 5% 0;">
    <div class="container">

        <div class="row d-flex" style="border:3px solid black">

            <div class="col-lg-12">
                <!-- <h2>Free <span style="color: #004aad;">COVID-19 Consultation For Indian Patients Only</span></h2> -->
                <div class="col-sm-12 heading-section text-center">
                    <h2> <span style="color: #004aad;font-weight:bold">Free Counseling</span></h2>
                </div>
                <p class="center-text-p font-weight-bold text-center">
                    eGlobalDoctors is working in association with TANA and AAPI volunteers
                    to make this counseling service possible for a variety of specialties.
                </p>

                <p class="center-text-p font-weight-bold text-center">
                    This service is not for emergencies.
                    Advise will be given by our doctors on a good faith, best effort basis.
                    Please consult your physician for full medical consultation.
                </p>
            </div>
            <div class="col-sm-12 col-lg-1"></div>
            <div class="col-sm-12 col-lg-3 text-muted lead text-center m-auto">
                <hr class="equip-tech-hr text-weight-bold">
                In Partnership With
            </div>
            <div class="col-sm-12 col-lg-3 mt-2 mb-5 text-center centerImg">
                <img src="assets/images/special/aapi.png" style="width:215px;height: 115px;margin: auto;"
                    alt="Free-Covid-Consultation-For-Indian-Patients">
            </div>
            <div class="col-sm-12 col-lg-3 mt-2 mb-5 text-center centerImg">
                <img src="assets/images/special/tana1.png" style="width:110px;margin: auto;"
                    alt="American Association of Physicians of Indian Origin">
            </div>

            <div class="col-sm-12 col-lg-2"></div>


            <div class="col-sm-12 col-lg-12 mt-2 mb-5">

                <h3 style="font-weight: 800; text-align: center;">Meeting Details</h3>
                <h4 style="font-weight: 800; text-align: center;">Need Help?<a href="https://youtu.be/dKUO0ibB6qk"
                        style="color:#004aad" target="_blank">(Watch Video)</a><img class="pl-1"
                        src="assets/images/playicon.png"></h4>
                <div class="row" *ngIf="this.response_success!=null && this.response_success">

                    <div class="col-sm-12 col-lg-6 text-center m-auto" style="margin-top: 3%;border: 1px solid black;">
                        <p class="font-weight-bolder" style="margin-top: 3%;font-size:16px;">Every Sunday</p>
                        <p class="font-weight-bolder" style="font-size:16px;">{{this.weekends[0][0]}} -
                            {{this.weekends[0][1]}}</p>
                        <p class="font-weight-bolder" style="font-size:16px;">{{this.weekends[1][0]}} -
                            {{this.weekends[1][1]}}(USA)</p>
                    </div>
                </div>
                <div class="novdashbtn col-sm-12 col-lg-12 d-flex" style="margin-top: 3%;">

                    <div class="row">

                        <button class="button-glow ui-button-info ui-button-rounded" pButton
                            style="display: block ruby;height: 50px;margin:10px;background:#004aad;width:170px;"
                            (click)="openZoomLink()">
                            <span style="font-size: 34px;vertical-align: middle;" class="icon-video_call"></span>
                            <span>Join Meeting</span>

                        </button>
                        <button class="button-glow ui-button-info ui-button-rounded text-dark bg-white" pButton
                            style="display: block ruby;height: 50px;margin:10px;width:170px;" (click)=" open_form()">
                            <span style="font-size: 34px;vertical-align: middle;" class="icon-video_call"></span>
                            <span style="color:#004aad;">Open Kobo Forms</span>

                        </button>
                        <img src="assets/images/arrow-right.png" class="novaarow"
                            style="width:50px;height:20px;margin-top:30px;">
                        <p class="font-weight-bolder mt-4 ml-1">

                            Login details<br>
                            id- egdocs_2021<br>
                            password- hVL8hgAC#']euY87
                        </p>





                    </div>

                </div>



            </div>

        </div>
    </div>
</section>
